// contexts/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../components/Firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../components/Firebase';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [userInfo, setUserInfo] = useState(null);
  const [roles, setRoles] = useState({});
  const [loading, setLoading] = useState(true);
  const [vipModeEnabled, setVipModeEnabled] = useState(false);

  useEffect(() => {
    const unsubscribeFlag = onSnapshot(doc(db, 'feature_flags', 'global'), (snap) => {
      if (snap.exists()) {
        setVipModeEnabled(snap.data().vipModeEnabled === true);
      } else {
        setVipModeEnabled(false);
      }
    });

    const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
      setLoading(true);

      if (user) {
        setUserInfo({
          uid: user.uid,
          email: user.email,
          emailVerified: user.emailVerified,
        });

        try {
          const idTokenResult = await user.getIdTokenResult(true);
          setRoles(idTokenResult.claims || {});
        } catch (err) {
          console.error('Błąd podczas pobierania claims:', err);
          setRoles({});
        }
      } else {
        setUserInfo(null);
        setRoles({});
      }

      setLoading(false);
    });

    return () => {
      unsubscribeFlag();
      unsubscribeAuth();
    };
  }, []);

  const hasRole = (role) => !!roles[role];

  const value = {
    user: userInfo,
    loading,
    roles,
    hasRole,
    isAdmin: hasRole('admin'),
    isVip: hasRole('vip'),
    vipModeEnabled,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth musi być używany wewnątrz AuthProvider');
  }
  return context;
};